import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

interface CampaignAveragesProps {
    averages: {
        messagesDelivered: number;
        read: number;
        clicks: number;
        conversions: number;
    };
}

const CampaignAveragesChart: React.FC<CampaignAveragesProps> = ({ averages }) => {
    ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

    const data = {
        labels: ['Delivered', 'Read', 'Clicks', 'Conversions'],
        datasets: [
            {
                label: 'Campaign Averages',
                data: [
                    averages.messagesDelivered,
                    averages.read,
                    averages.clicks,
                    averages.conversions,
                ],
                backgroundColor: ['#d6c5fc', '#b79af5', '#9f79ef', '#8a5de7'],
                borderRadius: 6,
            },
        ],
    };

    const options = {
        indexAxis: 'y' as const, // <- This makes the chart horizontal
        responsive: true,
        plugins: {
            legend: { display: false },
            datalabels: {
                anchor: 'end' as const,
                align: 'end' as const,
                clamp: true,
                formatter: (value: number) => `${Math.round(value)}%`,
                font: {
                    // weight: 'bold' as const,
                    size: 16,
                    family: 'quicksand-bold',
                },
                borderWidth: 2,
                color: '#000',
                borderRadius: 12,
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                stacked: true,
                ticks: {
                    stepSize: 10,
                    font: {
                        family: 'quicksand-bold'
                    }
                },
            },
            y: {
                stacked: true,
                ticks: {
                    precision: 0,
                    font: {
                        family: 'quicksand-bold'
                    }
                }
            },
        },
    };

    return <Bar data={data} options={options} height={80} plugins={[ChartDataLabels]} />;
};

export default CampaignAveragesChart;
